import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Pending from "@/pages/Pending";
import PortalLayout from "@/pages/portal/PortalLayout";
import Dashboard from "@/pages/portal/Dashboard";
import Statements from "@/pages/portal/Statements";
import Funds from "@/pages/portal/Funds";
import Messages from "@/pages/portal/Messages";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/Overview";
import AdminClients from "@/pages/admin/Clients";
import AdminFunds from "@/pages/admin/AdminFunds";
import AdminMessages from "@/pages/admin/AdminMessages";
import WelcomeEditor from "@/pages/admin/WelcomeEditor";
import OpsLayout from "@/pages/ops/OpsLayout";
import OpsOverview from "@/pages/ops/Overview";
import OpsLiveTrading from "@/pages/ops/LiveTrading";
import OpsBrain from "@/pages/ops/Brain";
import OpsCharts from "@/pages/ops/Charts";
import OpsAccounts from "@/pages/ops/Accounts";
import OpsPerformance from "@/pages/ops/Performance";
import OpsTradeHistory from "@/pages/ops/TradeHistory";
import OpsSystemLogs from "@/pages/ops/SystemLogs";
import OpsSettings from "@/pages/ops/Settings";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pending" element={<Pending />} />
      <Route
        path="/portal"
        element={
          <ProtectedRoute>
            <PortalLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="statements" element={<Statements />} />
        <Route path="funds" element={<Funds />} />
        <Route path="messages" element={<Messages />} />
      </Route>
      <Route
        path="/admin"
        element={
          <ProtectedRoute requireAdmin>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminOverview />} />
        <Route path="clients" element={<AdminClients />} />
        <Route path="funds" element={<AdminFunds />} />
        <Route path="messages" element={<AdminMessages />} />
        <Route path="welcome" element={<WelcomeEditor />} />
      </Route>
      <Route
        path="/ops"
        element={
          <ProtectedRoute requireAdmin>
            <OpsLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<OpsOverview />} />
        <Route path="trading" element={<OpsLiveTrading />} />
        <Route path="brain" element={<OpsBrain />} />
        <Route path="charts" element={<OpsCharts />} />
        <Route path="accounts" element={<OpsAccounts />} />
        <Route path="performance" element={<OpsPerformance />} />
        <Route path="history" element={<OpsTradeHistory />} />
        <Route path="logs" element={<OpsSystemLogs />} />
        <Route path="settings" element={<OpsSettings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
